<template>
    <Navbar v-if="!route.meta.hideNavbar" :phoneNumber="phoneNumber" />

    <main>
        <router-view />
    </main>

    <CTA v-if="!route.meta.hideCTA" :phoneNumber="phoneNumber" />
    <Footer />
</template>

<script setup>
import { useRoute } from 'vue-router'

import Navbar from '../components/Navbar.vue'
import CTA from '../components/CTA.vue'
import Footer from '../components/Footer.vue'
import { fetchContactData } from '@/services/api'
import { onMounted, ref } from 'vue'
const route = useRoute()
const phoneNumber = ref('')
onMounted(async () => {
    const response = await fetchContactData(false)
    if (response.contact) {
        phoneNumber.value = response.contact.whatsapp || ''
    }
})
</script>
